import BackendOrderManager from 'admin/order';

export default BackendOrderManager;
export const orderNum = 6;
export const title = 'VIP休假方案/訂單';
